import script from "./ChannelProductData.vue?vue&type=script&lang=ts&setup=true&name=ChannelProductData"
export * from "./ChannelProductData.vue?vue&type=script&lang=ts&setup=true&name=ChannelProductData"

const __exports__ = script;

export default __exports__